module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/users-bf8c8adcf44f5b3c54eca5fafbf6a07d.jpg";